import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import CommonLayout from "../../../../_utils/CommonLayout";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import globalText from "../../../../../utils/globalText";
import ICONS from "../../../../../assets/Icons";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";

const BeneTransactionStepAccount = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const disableCategories = true;
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [havePANAssociate, setHavePANAssociate] = useState(0);
  const [haveBankAssociate, setHaveBankAssociate] = useState(0);
  const [bankLogo, setBankLogo] = useState(
    props?.txnPayLoad?.bankLogo ? props?.txnPayLoad?.bankLogo : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [accountName, setAccountName] = useState(
    props?.txnPayLoad?.bankAccountName
      ? props?.txnPayLoad?.bankAccountName
      : "",
  );
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );

  const { beneSuccessData } = useSelector(
    (state) => state?.beneCreateAccountSlice,
  );
  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const unassignCategories = props?.categories.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !props?.category?.includes(unassignCategory.name),
  );

  const { beneLookData } = useSelector((state) => state.verify);
  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const shouldShowAssociatedAccounts =
    (haveBankAssociate > GlobalConfiguration?.lengthCheckOne ||
      havePANAssociate > GlobalConfiguration?.lengthCheckOne) &&
    accountNumber &&
    IFSC;

  useEffect(() => {
    if (props?.associateModalOpen) {
      document.querySelector("body").style.overflow = "hidden";
    } else {
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props?.associateModalOpen]);

  const handleUnassignNavigate = (id) => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/categories/${id}`,
      { replace: false },
    );
  };

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleOwnerSelection = (
    name,
    acc,
    ifsc,
    logo,
    ownerId,
    balance,
    lastFetched,
  ) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,

      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
      ownerBankBalance: balance,
      ownerLastUpdated: lastFetched,
    }));
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    setAccountName(accountName);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    const isRecreateFlow = props?.mapingData === "renderData";

    const isAccountChanged =
      props?.txnPayLoad?.beneAccountId &&
      props?.txnPayLoad?.beneAccountId !== beneAccountId;

    if (!isRecreateFlow || isAccountChanged) {
      props?.setSelectedCategory(null);
      props?.setCatShow(true);
      props?.setCatSelect(false);
    }

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      selectedCategory:
        isRecreateFlow && !isAccountChanged ? props?.selectedCategory : null,
      amountWords: "",
      mergeCategory: null,
    }));
    props?.setHasUserSelectedAccount(true);
    handleCloseModal();

    if (beneSuccessData?.beneficiary_accounts?.[0]?.id !== beneAccountId) {
      props?.setAccountSelect(false);
      props?.setCatShow(true);
    }
  };

  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() === category?.trim().toLowerCase(),
    );

    if (!categoryData || categoryData?.active !== "Y") {
      props?.setSelectedCategory(null);

      props?.setTxnPayLoad({
        ...props?.txnPayLoad,
        selectedCategory: null,
        mergeCategory: null,
      });

      return;
    }

    if (props?.selectedCategory?.name === category) return;

    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
      mergeCategory: null,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setStartDateCal({});
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  useEffect(() => {
    if (props?.mapingData === "renderData" && props?.accountSelect) {
      handleAccountSelection(
        beneSuccessData?.beneficiary_accounts?.[0]?.name,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_acc_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.ifsc_code,
        beneSuccessData?.beneficiary_accounts?.[0]?.bank_name,
        beneSuccessData?.beneficiary_accounts?.[0]?.category,
        beneSuccessData?.beneficiary_accounts?.[0]?.pan_no,
        beneSuccessData?.beneficiary_accounts?.[0]?.id,
        beneSuccessData?.beneficiary_accounts?.[0]?.labels,
      );
      props?.setCatShow(true);
    }
  }, [props?.mapingData, props?.accountSelect]);

  useEffect(() => {
    if (props?.mapingData === "renderSource" && props?.sourceSelect) {
      handleOwnerSelection(
        beneTxnAccountData?.transaction?.[0]?.owner_account_bank_name,
        beneTxnAccountData?.transaction?.[0]?.owner_account_bank_acc_no,
        beneTxnAccountData?.transaction?.[0]?.owner_account_ifsc_code,
        beneTxnAccountData?.transaction?.[0]?.owner_account_bank_name,
        beneTxnAccountData?.transaction?.[0]?.owner_account_id,
        beneTxnAccountData?.transaction?.[0]?.owner_account_balance,
        beneTxnAccountData?.transaction?.[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      );

      props?.setMapingData(null);
      props?.setSourceSelect(false);
    }
  }, [props?.mapingData, props?.sourceSelect]);

  useEffect(() => {
    setHaveBankAssociate(bankData?.total_count || 0);
    setHavePANAssociate(beneLookData?.total_count || 0);
  }, [beneLookData, bankData, dispatch]);

  useEffect(() => {
    if (props?.mapingCat === "renderCat" && props?.catSelect) {
      const categoryFromTxn = beneTxnAccountData?.transaction?.[0]?.category;

      const assignedCategories = props?.category || [];

      const isAssigned = assignedCategories?.some(
        (cat) =>
          cat?.trim().toLowerCase() === categoryFromTxn?.trim().toLowerCase(),
      );

      const categoryData = props?.categories?.find(
        (cat) =>
          cat.name?.trim().toLowerCase() ===
          categoryFromTxn?.trim().toLowerCase(),
      );

      if (!categoryData || !isAssigned) {
        props?.setSelectedCategory(null);
        props?.setCatSelect(false);

        props?.setTxnPayLoad((prev) => ({
          ...prev,
          selectedCategory: null,
          mergeCategory: null,
        }));

        props?.setMapingCat(null);
        return;
      }

      handleCategorySelect(categoryFromTxn);

      props?.setMapingCat(null);
    }
  }, [props?.mapingCat, props?.catSelect]);

  return (
    <>
      <div
        className={`w-width-full flex flex-col Qlg:px-padding-base px-padding-md gap-gap-md Qsmd:py-padding-md pt-padding-md max-w-tab-width-normal mx-auto`}
      >
        <CommonLayout>
          <div className="w-width-full  lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props?.openOwner}
              setModalOpen={props?.setOpenOwner}
              txnPayLoad={props?.txnPayLoad}
              setTxnPayLoad={props?.setTxnPayLoad}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div
            className={`w-width-full  lg:max-w-[var(--create-box-width)] ${
              !props?.txnPayLoad?.ownerBankAccountNo
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            <SourceDestinationAccountDetail
              type="destination"
              flow="beneficiary"
              modalOpen={props?.isModalOpen}
              setModalOpen={props?.setIsModalOpen}
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              shouldShowAssociatedAccounts={shouldShowAssociatedAccounts}
              handleOnAccountSelection={handleAccountSelection}
              activeType={activeType}
              setActiveType={setActiveType}
              setRemPan={setRemPan}
              setRemAccount={setRemAccount}
              setRemIFSC={setRemIFSC}
              remIFSC={remIFSC}
              remAccount={remAccount}
              remPan={remPan}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <ConfidentialCard
              icon={ICONS.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              onToggle={() => props?.setIsConfidential(!props?.isConfidential)}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-xl">
            <CategorySelector
              beneAccountId={beneAccountId}
              category={props?.category}
              selectedCategory={props?.selectedCategory}
              unassignCategories={unassignCategories}
              unassignlength={unassignlength}
              disableCategories={disableCategories}
              handleCategorySelect={handleCategorySelect}
              handleUnassignNavigate={handleUnassignNavigate}
              previewMode={false}
              enableSearch
              showUnassignCTA={true}
            />
          </div>
        </CommonLayout>

        <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
      </div>
    </>
  );
};

export default BeneTransactionStepAccount;
